import { cn } from "@/utils/cn";
import { memo } from "react";

interface ThumbsDownFilledIconProps {
  className?: string;
}

/**
 * Thumbs Down Filled Icon component
 * Used for dislike/disapprove actions when active/filled state
 */
export const ThumbsDownFilledIcon = memo(function ThumbsDownFilledIcon({
  className,
}: ThumbsDownFilledIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={cn(className)}
    >
      <path
        d="M21.9831 13.9688L20.8581 4.96875C20.7896 4.42489 20.5249 3.92475 20.1137 3.56224C19.7025 3.19974 19.1732 2.99981 18.625 3H2.5C2.10218 3 1.72064 3.15804 1.43934 3.43934C1.15804 3.72064 1 4.10218 1 4.5V12.75C1 13.1478 1.15804 13.5294 1.43934 13.8107C1.72064 14.092 2.10218 14.25 2.5 14.25H6.53687L10.0787 21.3356C10.1411 21.4602 10.2369 21.565 10.3555 21.6382C10.4741 21.7114 10.6107 21.7501 10.75 21.75C11.7446 21.75 12.6984 21.3549 13.4017 20.6516C14.1049 19.9484 14.5 18.9946 14.5 18V16.5H19.75C20.0693 16.5001 20.3849 16.4323 20.676 16.301C20.967 16.1697 21.2268 15.978 21.438 15.7385C21.6492 15.4991 21.8071 15.2175 21.9011 14.9123C21.9951 14.6072 22.023 14.2855 21.9831 13.9688Z"
        fill="currentColor"
      />
    </svg>
  );
});
